<template>
	<nav class="px-2">
		<ul>
			<slot></slot>
		</ul>
	</nav>
</template>

<script>
export default {};
</script>

<style lang="sass" scoped>
nav
	color: white
</style>
